import { render, staticRenderFns } from "./FrontFullPage.vue?vue&type=template&id=33d9aa4e&"
import script from "./FrontFullPage.vue?vue&type=script&lang=js&"
export * from "./FrontFullPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ploi/www.continental-holdings.com/web/app/themes/chc-wp-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33d9aa4e')) {
      api.createRecord('33d9aa4e', component.options)
    } else {
      api.reload('33d9aa4e', component.options)
    }
    module.hot.accept("./FrontFullPage.vue?vue&type=template&id=33d9aa4e&", function () {
      api.rerender('33d9aa4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/components/FrontFullPage.vue"
export default component.exports